import Nav from './components/Nav';
import AnimateOnPageLinks from './components/AnimateOnPageLinks';
import GoogleAdsScripts from './components/GoogleAdsScripts';
import FileArchive from './components/FileArchive';
import balanceText from 'balance-text';
import heroSwiper from './components/swiper/heroSwiper';

import StickyHeader from './components/StickyHeader';
import SingleProduct from './components/product/singleProduct';
import Komplettasystem from './components/Komplettasystem';
import FancyInit from './components/FancyInit';
import ReadingPosition from '@10up/reading-position';
import BoxInfoBlock from './components/Boxinfo';
import SectionNav from './components/SectionNav';
import productSwiper from './components/product/productSwiper';
import realHv from './components/realHv';
import ReadMoreFade from './components/ReadMoreFade';
// import Swiper styles
import 'swiper/css';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
import karusellSwiper from './components/swiper/karusellSwiper';

realHv();

jQuery(function ($) {
	heroSwiper.init();
	karusellSwiper.init();
	productSwiper.initNav();
	productSwiper.init();

	StickyHeader();
	GoogleAdsScripts.init();
	Nav.init();
	AnimateOnPageLinks.init();
	FileArchive.init();

	SingleProduct.init();
	Komplettasystem.init();
	FancyInit.init();
	BoxInfoBlock.init();
	SectionNav.init();

	// Init Balancetext
	balanceText();
	balanceText('.balancetext');

	if (jQuery('.orderby')[0]) {
		// Select 2
		jQuery('.orderby').select2({ width: '180px' });
	}

	const toggleProductForm = $(document).find('[data-show-form]');

	toggleProductForm.on('click', function (e) {
		e.preventDefault();
		const target = $(this).attr('data-show-form');
		$(target).toggle();
	});
});

new ReadingPosition('.reading-position', {});

window.addEventListener(
	'scroll',
	function () {
		StickyHeader();
	},
	{ passive: true }
);

// rezie
window.addEventListener('resize', function () {
	StickyHeader();
});

// load
window.addEventListener('load', function () {
	StickyHeader();
});

// Scroll to top
jQuery('.to-top').on('click', function (event) {
	event.preventDefault();
	jQuery('html, body').animate(
		{
			scrollTop: 0,
		},
		500
	);
});

jQuery(document).ready(function($) {
	$('a[data-show-form="#product-form"]').on('click', function(e) {
	  e.preventDefault();
  
	  // Lägg till klass på föregående notpurchasable-text
	  $(this).toggleClass('clicked');
  
	});
  });
  

/* document.addEventListener('DOMContentLoaded', function () {
	var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

	if ('IntersectionObserver' in window) {
		var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (video) {
				if (video.isIntersecting) {
					for (var source in video.target.children) {
						var videoSource = video.target.children[source];
						if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
							videoSource.src = videoSource.dataset.src;
						}
					}

					video.target.load();
					video.target.classList.remove('lazy');
					lazyVideoObserver.unobserve(video.target);
				}
			});
		});

		lazyVideos.forEach(function (lazyVideo) {
			lazyVideoObserver.observe(lazyVideo);
		});
	}
});
 */
